import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import Card from '../../components/base/Card';
import Button from '../../components/base/Button';
import HeroSection from './components/HeroSection';
import CourseOverview from './components/CourseOverview';
import KnowledgeMapPreview from './components/KnowledgeMapPreview';
import LearningPaths from './components/LearningPaths';
import Features from './components/Features';
import ContactForm from './components/ContactForm';

export default function Home() {
  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      <main>
        {/* Hero Section */}
        <HeroSection />

        {/* Features Section */}
        <Features />

        {/* Course Overview */}
        <CourseOverview />

        {/* Knowledge Map Preview */}
        <KnowledgeMapPreview />

        {/* Learning Paths */}
        <LearningPaths />

        <ContactForm />
      </main>
      <Footer />
    </div>
  );
}
